import { type FixingDetails, Stack, Text, Tooltip } from '@talos/kyoko';
import { values } from 'lodash-es';
import { useFixingIndices } from '../../../../providers/FixingIndexProvider';

/** Given a FixingDetails object, will return a label (text-ish element) which renders the index or indices within the FixingDetails object */
export const FixingDetailsIndicesLabel = ({ fixingDetails }: { fixingDetails: FixingDetails | undefined }) => {
  const { fixingIndicesByName } = useFixingIndices();

  if (fixingDetails?.Index) {
    return <Text>{fixingIndicesByName.get(fixingDetails.Index)?.DisplayName ?? fixingDetails.Index}</Text>;
  }

  if (fixingDetails?.MultilegFixingDetails) {
    const fixings = values(fixingDetails.MultilegFixingDetails);

    if (fixings.length === 1) {
      const fixing = fixings[0];
      return <Text>{fixingIndicesByName.get(fixing.Index)?.DisplayName ?? fixing.Index}</Text>;
    }

    return (
      <Tooltip
        showUnderline
        tooltip={
          <Stack gap="spacing2">
            {fixings.map(fixing => (
              <Text key={fixing.Index}>{fixingIndicesByName.get(fixing.Index)?.DisplayName ?? fixing.Index}</Text>
            ))}
          </Stack>
        }
      >
        <Text>{fixings.length} indices</Text>
      </Tooltip>
    );
  }

  return null;
};
